import React from "react";
import {
    Button,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    useDisclosure,
    useToast,
    HStack,
} from "@chakra-ui/react";
import { DELETE_RECRUITER_MUTATION } from "../../graphql/agencies";
import MoblyzeApolloClient from "../../services/MoblyzeApolloClient";

const DeleteRecruiterButton = ({ user, refetch }) => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const toast = useToast();

    const handleDelete = async (id) => {
        onClose();
        try {
            await MoblyzeApolloClient.mutate({
                mutation: DELETE_RECRUITER_MUTATION,
                variables: {
                    id: id,
                },
            });
            toast({
                title: "Recruiter deleted successfully",
                status: "success",
                duration: 5000,
                isClosable: true,
            });
            refetch();
        } catch (error) {
            console.error("Error deleting recruiter:", error);
            toast({
                title: "Error",
                description: "Failed to delete recruiter.",
                status: "error",
                duration: 5000,
                isClosable: true,
            });
        }
    }
    if (!user || !user.id || user.isOwner) {
        return null;
    }

    return (
        <>
            <Button
                colorScheme="red"
                size="sm"
                onClick={onOpen}
            >Delete</Button>
            <Modal isOpen={isOpen} onClose={onClose} isCentered variant={"darkMode"} size="md">
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Delete Recruiter</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        Are you sure you want to delete recruiter {user.fullName}?
                    </ModalBody>
                    <ModalFooter>
                        <HStack spacing={3}>
                            <Button colorScheme="red" onClick={() => handleDelete(user.id)}>Delete</Button>
                            <Button variant="outline" onClick={onClose}>Cancel</Button>
                        </HStack>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    );
};

export default DeleteRecruiterButton;